var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9004 16.6665H4.23291V17.5002C4.23291 17.7214 4.14507 17.9334 3.98871 18.0898C3.83235 18.2461 3.62028 18.334 3.39916 18.334H2.56666C2.34554 18.334 2.13347 18.2461 1.97711 18.0898C1.82075 17.9334 1.73291 17.7214 1.73291 17.5002V9.16649L3.80041 4.34399C3.929 4.04389 4.14291 3.78818 4.41558 3.60862C4.68826 3.42906 5.00768 3.33356 5.33416 3.33399H14.8004C15.1265 3.33405 15.4453 3.42978 15.7175 3.60931C15.9897 3.78884 16.2032 4.04428 16.3317 4.34399L18.4004 9.16774V17.5002C18.4004 17.7214 18.3126 17.9334 18.1562 18.0898C17.9999 18.2461 17.7878 18.334 17.5667 18.334H16.7329C16.512 18.3337 16.3003 18.2457 16.1442 18.0893C15.9881 17.933 15.9004 17.7211 15.9004 17.5002V16.6665ZM16.7342 10.8327H3.40041V15.0002H16.7329L16.7342 10.8327ZM3.54666 9.16649H16.5867L14.8004 5.00024H5.33291L3.54791 9.16649H3.54666Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 12.3398H14.6345V13.5898H5.49951V12.3398Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleRed);
export default __webpack_public_path__ + "static/media/vehicle-red.19acaae48f7eb5edf95dfce91e5be223.svg";
export { ForwardRef as ReactComponent };